module.exports = __webpack_public_path__ + "static/media/cellulite-stop.b0206707.pdf";